import { HeaderGroup } from 'react-table';

import { AlignText } from 'coreOld/enums';

import { Th, Thead, Tr } from './headerStyle';

interface IProps {
  headerGroups: HeaderGroup<object>[];
  borderBottom?: boolean;
  lines?: number;
  hasRowSelection?: boolean;
  textAlign?: AlignText;
}

const HeaderView = ({ headerGroups, textAlign }: IProps) => {
  return (
    <Thead>
      {headerGroups.map((headerGroup, index) => (
        <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
          {headerGroup.headers.map((column, index) => (
            <Th {...column.getHeaderProps({})} key={index} textAlign={textAlign}>
              {column.render('Header')}
            </Th>
          ))}
        </Tr>
      ))}
    </Thead>
  );
};

export default HeaderView;
